<input class="mydrug" [(ngModel)]="drug"/>
<button class="delete-drug-button" (click)="onClick()">x</button>
